import axiosInstance from "../instance/axiosInstance";

class UsersApi {
  static async usersList(page, queryParams) {
    const { search_status, search_department, search_value, search_branch } = queryParams;
    let url = `/organization/user/list?page=${page}`;

    if (search_status) {
      url += `&search_status=${search_status}`;
    }
    if (search_branch) {
      url += `&search_branch=${search_branch}`;
    }
    if (search_department) {
      url += `&search_department=${search_department}`;
    }

    if (search_value) {
      url += `&search_value=${search_value}`;
    }

    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async temporaryUsersList(page, queryParams) {
    const { search_status, search_value } = queryParams;
    let url = `/organization/user/temporary-list?page=${page}`;

    if (search_status || search_status === 0) {
      url += `&search_status=${search_status}`;
    }

    if (search_value) {
      url += `&search_value=${search_value}`;
    }

    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async createUser(formData) {
    try {
      const response = await axiosInstance.post(
        "/organization/user/save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async createTemporaryUser(formData) {
    try {
      const response = await axiosInstance.post(
        "/organization/user/temporary-save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getUsersListWithoutPg() {
    try {
      const response = await axiosInstance.get(
        "/organization/user/dropdown-list"
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getSharedCabinets() {
    try {
      const response = await axiosInstance.get("cabinet/temporary-dropdown");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async changeUserStatus(formData) {
    try {
      const response = await axiosInstance.put(
        "/organization/user/status-update",
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async deleteUser(id) {
    try {
      const response = await axiosInstance.get(
        `/organization/user/delete/${id}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getTempSingleUser(id) {
    try {
      const response = await axiosInstance.get(
        `/organization/user/temporary-view/${id}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getSingleUser(id) {
    try {
      const response = await axiosInstance.get(`/organization/user/get/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getUserHistory(id) {
    try {
      const response = await axiosInstance.get(
        `/organization/user/update-history/${id}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getUsersByDepartment(id) {
    try {
      const response = await axiosInstance.get(`/getUsersByDepartment/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getPermissionData() {
    try {
      const response = await axiosInstance.get(`/permissoins-data`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getTempUserLimit() {
    try {
      const response = await axiosInstance.get(`/temp-user-limit-check`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default UsersApi;
